import React from "react";
const Pic =()=>{
   return(
    <div style={{width: "100%"}}>
      <img src={'https://cdn.getprepped.in/getpreppedLogoBig.svg'} alt="" style={{width: "40%"}} />
    </div>
   )
}

export default Pic 